<template>
    <div class="consultas-carta-proposta">
        <g-card class="card-consultas-carta-header" :expansivel="false" :temCabecalho="false">
            <div class="header-detalhes-secundario">
                <div class="header-detalhes-secundario-titulo">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />
                    <div class="titulo-detalhes-cabecalho"> Detalhes da Carta-Proposta</div>
                </div>
                <div class="header-icons">
                    <g-button
                    class=""
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    @click="TelaDetalhes()"
                    >
                    </g-button>
                    <g-button
                    class=""
                    altura="35px"
                    largura="100px"
                    tamanhoIcone="15px"
                    @click="this.$router.push(`/carta-proposta-rascunho/${this.CartaPropostaId}`)"
                    >
                    Rascunho
                    </g-button>
                </div>
            </div>
            <div class="espacamento-detalhes">
                <div class="titulo-grupo-detalhes">Dados da Carta-Proposta</div>
                <div class="dados_carta">
                    <div class="dados_carta_versao">
                        <div class="titulo-conteudo-detalhes">Carta - Versão</div>
                        <div class="label-conteudo"
                        >{{InformacoesCartaPropostaSelecionado.codigoExterno || 'Não Cadastrado'}}
                        </div>
                    </div>
                    <div class="dados_carta_cliente">
                        <div class="titulo-conteudo-detalhes">Cliente</div>
                        <div class="label-conteudo">{{InformacoesCartaPropostaSelecionado.razaoSocial || 'Não Cadastrado'}}</div>
                    </div>
                    <div class="dados_carta_codigo">
                        <div class="titulo-conteudo-detalhes">Código Cliente</div>
                        <div class="label-conteudo">{{InformacoesCartaPropostaSelecionado.codigoCliente || 'Não Cadastrado' }}</div>
                    </div>
                    <div class="dados_carta_cnpj">
                        <div class="titulo-conteudo-detalhes">CNPJ</div>
                        <div class="label-conteudo label-conteudo">
                            <label>
                                {{MascaraCnpj || 'Não Cadastrado'}}
                            </label>
                        </div>
                    </div>
                    <div class="dados_carta_unidade">
                        <div class="titulo-conteudo-detalhes">Unidade</div>
                        <div class="label-conteudo">{{InformacoesCartaPropostaSelecionado.nomeEmpresa || 'Não Cadastrado'}}</div>
                    </div>
                    <div class="dados_carta_representante">
                        <div class="titulo-conteudo-detalhes">Representante</div>
                        <div class="label-conteudo">{{InformacoesCartaPropostaSelecionado.nomeRepresentante || 'Não Cadastrado'}}</div>
                    </div>
                    <div class="dados_carta_cv">
                        <div class="titulo-conteudo-detalhes">CV</div>
                        <div class="label-conteudo">{{InformacoesCartaPropostaSelecionado.curvaCliente || 'Não Cadastrado'}}
                        </div>
                    </div>
                </div>

                <div class="titulo-grupo-detalhes">Observações da Negociação</div>
                <div class="dados_observacoes">

                    <div class="condicao-pagamennto">
                        <div class="titulo-conteudo-detalhes">Condições de Pagamento</div>
                        <div class="label-conteudo"
                        >{{InformacoesCartaPropostaSelecionado.formaDePagamento || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="data-digitacao">
                        <div class="titulo-conteudo-detalhes">Data da digitação</div>
                        <div class="label-conteudo"
                        > {{InformacoesCartaPropostaSelecionado.dataDigitacaoFormatada || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="status">
                        <div class="titulo-conteudo-detalhes">Status</div>
                        <div class="label-conteudo"
                        > {{InformacoesCartaPropostaSelecionado.statusEnumCCP}}</div>
                    </div>

                    <div class="obs-neg">
                        <div class="titulo-conteudo-detalhes">Observações da negociação</div>
                        <div class="label-conteudo" 
                        v-for="obs in this.ObservacoesNegociacaoOriginalTextoCortado "
                        :key="obs.id"> 
                        {{obs || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="obs-prod">
                        <div class="titulo-conteudo-detalhes">Observações do Produto</div>
                        <div class="resultado-observacao observacao-produto">
                            {{InformacoesCartaPropostaSelecionado.observacaoProduto || 'Não Cadastrado'}}
                        </div>
                    </div>

                </div>
                <div class="dados_orcamento">
                    <div class="titulo-grupo-detalhes">Orçamentos</div>
                    <div class="Orcamento_infos">
                        <div class="label-conteudo" v-if="!orcamentosCartaProposta.length">Não Possui</div>
                        <div class="engloba-lista"
                            v-for="(orcamento, index) in orcamentosCartaProposta" :key="index">
                            <div class="item-orcamento">
                                <div class="info-orcamento">{{orcamento.numeroOrcamento}} - {{orcamento.nomeProduto}}</div>
                                <div class="engloba-botoes-detalhes">
                                    <div class="detalhes" @click="enviaDetalhesOrcamento(orcamento)">Detalhe</div>
                                    <div class="markup" @click="getMarkupInformacoes(orcamento)">Markup</div>
                                </div>
                            </div>
                            <div class="container-infos" v-if="orcamento.infos">
                                <div class="engloba-observacao">
                                    <div class="titulo-conteudo-detalhes">Obervações da Opção</div>
                                    <div class="label-conteudo" style="text-align: left;">{{ orcamento.descricaoOpcao }}</div>
                                </div>
                                <div class="engloba-quantidade">
                                    <div class="titulo-conteudo-detalhes">Qtde.</div>
                                    <div class="label-conteudo" :key="orcamento.orcamentoId+index" v-for="(info, index) in orcamento.infos" style="text-align: left;">{{ formataDecimal(info.quantidade) }}</div>
                                </div>
                                <div class="engloba-preco">
                                    <div class="titulo-conteudo-detalhes">Preço</div>
                                    <div class="label-conteudo" :key="orcamento.orcamentoId+index" v-for="(info, index) in orcamento.infos" style="text-align: left;">{{'R$ ' + info.precoFormatado }}</div>
                                </div>
                                <div class="engloba-comissao">
                                    <div class="titulo-conteudo-detalhes">Comissão Vend.</div>
                                    <div class="label-conteudo" :key="orcamento.orcamentoId+index" v-for="(info, index) in orcamento.infos" style="text-align: left;">{{ info.comissaoFormatada }}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </g-card>
    </div>
</template>

<script>
import Detalhe from "./DetalheCartaProposta.js";

export default Detalhe;
</script>

<style scoped>
.Orcamento_infos{
    padding-top: 1%;
}
.topico-linha{
    border-bottom: 1px solid #f0f0f0;
}
.titulo-grupo{
    color: #4f2c19;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: bold;
    padding: 30px 0 10px;
    font-size: 20px;
}
.header-detalhes{
    width: 100%;
    padding: 20px 0 10px;
    border-bottom: 1px solid #f0f0f0;
}
.consultas-carta-proposta {
    padding: 10px;
}

.card-consultas-carta-proposta-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
}
    .resultado-observacao{
        text-align: left;
        letter-spacing: 0px;
        color: #8a8a8a;
        opacity: 1;
        font-size: 16px;
    }

    .titulo_geral{
        text-align: left;
        font-family: "MontSerrat";
        font-weight: 700;
        margin-top: 15px;
        color: #4F2C19;
    }

    .observacao-produto{
    font-family: monospace;
    max-width: 50ch;
    white-space: break-spaces;
    }
    /* Card Consultas - Produtos por Cliente */
    .card-consultas-produtos-cliente-header {
        display: flex;
        width: 100%;
    }

    .card-consultas-produtos-cliente-titulo {
        color: #4f2c19;
        font-weight: bold;
        font-size: 1.3rem;
    }
    .card-consultas-produtos-cliente-print {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    padding-right: 15px;
    }

    

    /* .dados_orcamento {
    display: grid;
    grid-template-columns: repeat(2, 177px);
    grid-template-rows: 0.5fr 1fr 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 9px;
    }

    .dados_orcamento_fiscais {grid-area: 1 / 1 / 2 / 2;} */



    /* .dados_observacoes {
    display: grid;
    grid-template-columns: 15% 15% 15% 65%;
    grid-template-rows: 40%;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    }

   .dados_observacoes_contato {grid-area: 1 / 1 / 2 / 2;}
   .dados_observacoes_Telefone_box { grid-area: 2 / 1 / 3 / 2; }
   .dados_observacoes_celular_box { grid-area: 2 / 2 / 3 / 3; }
   .dados_observacoes_email {grid-area: 3 / 1 / 3 / 2; }
  .dados_observacoes_site_box{grid-area: 3/ 2 / 4 / 3; } */


    .titulo_cli{
        text-align: left;
        letter-spacing: 0px;
        font-size: 17px;
        font-weight: bold;
        color: #4F2C19;
        opacity: 1;
    }

    .label{
        text-align: left;
        letter-spacing: 0px;
        color: #3E3E3E;
        font-weight: bold;
        opacity: 1;
        font-size: 14px;
    }
    .resultado{
         color: #8a8a8a;
        text-align: left;
        font-family: "MontSerrat";
        margin-bottom: 10px;
    }

    .resultado-teste{
        text-align: left;
        letter-spacing: 0px;
        color: #3E3E3E;
        opacity: 1;
        font-size: 14px;
    }



@media (min-width:310px) {
    .label{
        text-align: left;
        letter-spacing: 0px;
        color: #3E3E3E;
        font-weight: bold;
        opacity: 1;
        font-size: 14px;
    }
    .item-orcamento{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    .container-infos{
        /* padding: 0 0.5rem; */
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .dados_carta {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 2 / 1 / 3 / 3; }
    .dados_carta_versao { grid-area: 3 / 1 / 4 / 3; }
    .dados_carta_cnpj { grid-area: 4 / 1 / 5 / 3;}
    .dados_carta_unidade { grid-area: 5 / 1 / 6 / 3 ;}
    .dados_carta_representante { grid-area: 6 / 1 / 7 / 2 ;}
    .dados_carta_cv { grid-area: 7 / 1 / 8 / 2 ;} */

}

@media (min-width:368px) {
    .dados_carta{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(4, 1fr);
        gap: 2%;
    }
}

@media (min-width:600px) {

    .dados_observacoes{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, auto);
        grid-column-gap: 5px;
        grid-row-gap: 5px;
    }

    .condicao-pagamento{grid-area: 1 / 1 / 2 / 2;}
    .data-digitacao{grid-area: 1 / 2 / 2 / 3;}
    .status{grid-area: 1 / 3 / 2 / 4;}
    .obs-prod{grid-area: 3 / 1 / 4 / 4;}
    .obs-neg{grid-area: 2 / 1 / 3 / 4;}
    .item-orcamento{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }

    .dados_carta {
        grid-template-rows: repeat(4, auto);
    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 1 / 3 / 2 / 4; }
    .dados_carta_versao { grid-area: 2 / 1 / 3 / 2; }
    .dados_carta_cnpj { grid-area: 2 / 2 / 3 / 3;}
    .dados_carta_unidade { grid-area: 2 / 3 / 3 / 4 ;}
    .dados_carta_representante { grid-area: 3 / 1 / 4 / 2 ;}
    .dados_carta_cv { grid-area: 3 / 2 / 4 / 3 ;} */

}

@media (min-width:801px) {
    .dados_observacoes{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, auto);
        grid-column-gap: 5px;
        grid-row-gap: 5px;
    }

    .condicao-pagamento{grid-area: 1 / 1 / 2 / 2;}
    .data-digitacao{grid-area: 1 / 2 / 2 / 3;}
    .status{grid-area: 1 / 3 / 2 / 4;}
    .obs-prod{grid-area: 3 / 1 / 4 / 4;}
    .obs-neg{grid-area: 2 / 1 / 3 / 4;}
    .container-infos{
    /* padding: 0 0.5rem; */
    display: flex;
    flex-direction: row;
    gap: 5em;
}

    .botoes {
    display: flex;
    margin-top: 0.8rem;
    border-radius: 5px;
    margin-left: 5px;
    }

    .dados_carta {
        grid-template-columns: repeat(3, minmax(4em, 1fr));
        grid-template-rows: repeat(3, auto);
        column-gap: 3%;
    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 1 / 3 / 2 / 4; }
    .dados_carta_versao { grid-area: 1 / 4 / 2 / 5; }
    .dados_carta_cnpj { grid-area: 1 / 5 / 2 / 6;}
    .dados_carta_unidade { grid-area: 2 / 1 / 3 / 2 ;}
    .dados_carta_representante { grid-area: 2 / 2 / 3 / 3 ;}
    .dados_carta_cv { grid-area: 2 / 3 / 3 / 4 ;} */

    /* .dados_orcamento {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: 10% 30% 30% 30%;
    grid-column-gap: 10px;
    grid-row-gap: 25px;
    }
    .dados_orcamento_fiscais {grid-area: 1 / 1 / 2 / 2;} */
    /* .dados_observacoes {
    display: grid;
    grid-template-columns: 15% 15% 15% 65%;
    grid-template-rows: 40%;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    }

   .dados_observacoes_contato {grid-area: 1 / 1 / 2 / 2;}
   .dados_observacoes_Telefone_box { grid-area: 2 / 1 / 3 / 2; }
   .dados_observacoes_celular_box { grid-area: 2 / 2 / 3 / 3; }
   .dados_observacoes_email {grid-area: 2 / 3 / 3 / 4; }
   .dados_observacoes_site_box{grid-area: 2 / 4 / 3 / 5;} */

}

@media (min-width:1025px) {

    .dados_observacoes{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, auto);
        grid-column-gap: 5px;
        grid-row-gap: 5px;
    }

    .condicao-pagamento{grid-area: 1 / 1 / 2 / 2;}
    .data-digitacao{grid-area: 1 / 2 / 2 / 3;}
    .status{grid-area: 1 / 3 / 2 / 4;}
    .obs-prod{grid-area: 3 / 1 / 4 / 4;}
    .obs-neg{grid-area: 2 / 1 / 3 / 4;}

    

    .botoes {
    display: flex;
    margin-top: 0.8rem;
    border-radius: 5px;
    margin-left: 5px;
    }

    .dados_carta {
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;

    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 1 / 3 / 2 / 4; }
    .dados_carta_versao { grid-area: 1 / 4 / 2 / 5; }
    .dados_carta_cnpj { grid-area: 1 / 5 / 2 / 6;}
    .dados_carta_unidade { grid-area: 2 / 1 / 3 / 2 ;}
    .dados_carta_representante { grid-area: 2 / 2 / 3 / 3 ;}
    .dados_carta_cv { grid-area: 2 / 3 / 3 / 4 ;} */

/*
.dados_orcamento {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 10% 30% 30% 30%;
    grid-column-gap: 10px;
    grid-row-gap: 15px;
    }
    .dados_orcamento_fiscais {grid-area: 1 / 1 / 2 / 2;} */

    /* .dados_observacoes {
    display: grid;
    grid-template-columns: 15% 15% 15% 65%;
    grid-template-rows: 40%;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    }

   .dados_observacoes_contato {grid-area: 1 / 1 / 2 / 2;}
   .dados_observacoes_Telefone_box { grid-area: 2 / 1 / 3 / 2; }
   .dados_observacoes_celular_box { grid-area: 2 / 2 / 3 / 3; }
   .dados_observacoes_email {grid-area: 2 / 3 / 3 / 4; }
   .dados_observacoes_site_box{grid-area: 2 / 4 / 3 / 5;} */


}

@media (min-width:1281px) {

    .botoes {
    display: flex;
    margin-top: 0.8rem;
    border-radius: 5px;
    margin-left: 5px;
    }

    .dados_carta {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 1 / 3 / 2 / 4; }
    .dados_carta_versao { grid-area: 1 / 4 / 2 / 5; }
    .dados_carta_cnpj { grid-area: 1 / 5 / 2 / 6;}
    .dados_carta_unidade { grid-area: 1 / 6 / 3 / 7 ;}
    .dados_carta_representante { grid-area: 1 / 7 / 2 / 8 ;}
    .dados_carta_cv { grid-area: 1 / 8 / 2 / 9 ;} */

    /* .dados_orcamento {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 10% 30% 30% 30%;
    grid-column-gap: 10px;
    grid-row-gap: 15px;
    }
    .dados_orcamento_fiscais {grid-area: 1 / 1 / 2 / 2;} */


    /* .dados_observacoes {
    display: grid;
    grid-template-columns: 15% 15% 15% 65%;
    grid-template-rows: 40%;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    }

   .dados_observacoes_contato {grid-area: 1 / 1 / 2 / 2;}
   .dados_observacoes_Telefone_box { grid-area: 2 / 1 / 3 / 2; }
   .dados_observacoes_celular_box { grid-area: 2 / 2 / 3 / 3; }
   .dados_observacoes_email {grid-area: 2 / 3 / 3 / 4; }
   .dados_observacoes_site_box{grid-area: 2 / 4 / 3 / 5;} */


}




@media (min-width:1500px) {

    .botoes {
        display: flex;
        margin-top: 0.8rem;
        border-radius: 5px;
        margin-left: 5px;
    }

    .dados_carta {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    /* .dados_carta_cliente { grid-area: 1 / 1 / 2 / 3; }
    .dados_carta_codigo { grid-area: 1 / 3 / 2 / 4; }
    .dados_carta_versao { grid-area: 1 / 4 / 2 / 5; }
    .dados_carta_cnpj { grid-area: 1 / 5 / 2 / 6;}
    .dados_carta_unidade { grid-area: 1 / 6 / 3 / 7 ;}
    .dados_carta_representante { grid-area: 1 / 7 / 2 / 8 ;}
    .dados_carta_cv { grid-area: 1 / 8 / 2 / 9 ;} */

/*
    .dados_orcamento {
        display: grid;
        grid-template-columns: 1fr;
    }

    .dados_orcamento_fiscais {grid-area: 1 / 1 / 2 / 2;} */


    /* .dados_observacoes {
    display: grid;
    grid-template-columns: 15% 15% 15% 65%;
    grid-template-rows: 40%;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    } */

   /* .dados_observacoes_contato {grid-area: 1 / 1 / 2 / 2;}
   .dados_observacoes_Telefone_box { grid-area: 2 / 1 / 3 / 2; }
   .dados_observacoes_celular_box { grid-area: 2 / 2 / 3 / 3; }
   .dados_observacoes_email {grid-area: 2 / 3 / 3 / 4; }
   .dados_observacoes_site_box{grid-area: 2 / 4 / 3 / 5;} */
}

.engloba-lista{
    transition: 0.5s;
    /* height: 0px; */
}

.markup{
    cursor: pointer;
    font: normal normal 600 13px/23px Montserrat;
    color: #5a5a5a;
    text-decoration: underline;
    align-items: baseline;
}

.detalhes{
    cursor: pointer;
    font: normal normal 600 13px/23px Montserrat;
    color: #5a5a5a;
    text-decoration: underline;
    align-items: baseline;
}

.info-orcamento{
    text-align: left;
    color: #8a8a8a;
    font-family: "MontSerrat";
    margin-bottom: 10px;
}

.tabela-quantidade{
    margin-bottom: 1rem;
}

.td-tabela-quantidade{
    padding: 0 100px;
}

.label-observacao{
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 700;
    margin-top: 15px;
    color: #4F2C19;
}

.engloba-observacao{
    margin-bottom: 1rem;
}

.engloba-botoes-detalhes{
    display: flex;
    gap: 1rem;
}
</style>

